import { useMutation, useQueryClient } from '@tanstack/react-query'
import { reactQueryName } from 'reactQueryKeys/reactQueryKeys'
import { updateCardStatus } from 'services/CardService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { logSentryError } from 'utils/sentry'

export const useUpdateCardStatusMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateCardStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [reactQueryName.CARDS] })
    },
    onError: (error: BaseErrorResponse) => {
      logSentryError('Error: useUpdateCardStatusMutation', error)
    },
  })
}
